import { usePagination } from '@src/store/hooks/usePagination';
import { useMemo } from 'react';
import { type LoadMoreReportsParams, loadMoreReportsAtom, type ReportCollectionCompositeKeyParams, reportCollectionAtomFamily } from '../reports';

export interface UsePaginatedReportsPayload {
    tokenName: string;
    fetchLimit?: number;
    status?: string; // 'New', 'Done', 'Rejected', 'all'
    type?: string; // 'User', 'Post', 'Comment', 'Community', 'all'
}

export const usePaginatedReports = (payload: UsePaginatedReportsPayload) => {
    const getParams = useMemo(
        () =>
            (payload: UsePaginatedReportsPayload): ReportCollectionCompositeKeyParams & { fetchLimit: number } => ({
                tokenName: payload.tokenName,
                fetchLimit: payload.fetchLimit ?? 20,
                ...(payload.status && payload.status !== 'all' && { status: payload.status }),
                ...(payload.type && payload.type !== 'all' && { type: payload.type }),
            }),
        []
    );

    const getLoadMoreParams = useMemo(
        () =>
            (params: ReportCollectionCompositeKeyParams & { fetchLimit?: number }, fetchLimit: number): LoadMoreReportsParams => ({
                tokenName: params.tokenName,
                fetchLimit,
                ...(params.status && { status: params.status }),
                ...(params.type && { type: params.type }),
            }),
        []
    );

    const { ids, loadMore, hasMore, loadStatus, error } = usePagination(payload, {
        collectionStateFamily: reportCollectionAtomFamily,
        // @ts-expect-error - Type mismatch between createLoadMoreAtom and usePagination interface
        loadMoreAtom: loadMoreReportsAtom,
        getParams,
        getLoadMoreParams,
        entityType: 'Report',
    });

    return {
        reportIds: ids,
        loadMore,
        hasMore,
        loadStatus,
        error,
    };
};
